import { FunctionComponent } from 'react'
import { DatingApp, FBMessenger, SMS, WhatsApp, parseHtml } from '@horizontal-org/shira-ui';
import type { UIExplanation } from '../../types';

interface Props {
  content: string;
  name: string;
  explanations?: UIExplanation[];
  explanationNumber: number;
  showExplanations: boolean
  images?: Array<{ imageId: number; url: string }>
}

export const MessagingApps: FunctionComponent<Props> = ({ content, name, explanations, explanationNumber, showExplanations, images }) => {

  const { parseCustomElement, getDocument } = parseHtml(content, images)

  const contentRoot = getMessagingContentRoot(getDocument())
  const phone = parseCustomElement('component-required-phone')
  const senderName = getSenderName(parseCustomElement)

  return (
    <>
      {name === 'SMS' && (
        <SMS
          phone={phone}
          content={contentRoot}
          explanations={explanations}
          explanationNumber={explanationNumber}
          showExplanations={showExplanations}
        />
      )}

      {name === 'Dating App' && (
        <DatingApp
          senderName={senderName}
          content={contentRoot}
          explanations={explanations}
          explanationNumber={explanationNumber}
          showExplanations={showExplanations}
        />
      )}

      {name === 'WhatsApp' && (
        <WhatsApp
          phone={phone}
          content={contentRoot}
          explanations={explanations}
          explanationNumber={explanationNumber}
          showExplanations={showExplanations}
        />
      )}

      {name === 'Messenger' && (
        <FBMessenger
          senderName={senderName}
          content={contentRoot}
          explanations={explanations}
          explanationNumber={explanationNumber}
          showExplanations={showExplanations}
        />
      )}
    </>
  )
}

const getMessagingContentRoot = (html: Document) => {
  const dynamicContent = html.getElementById('dynamic-content')

  if (dynamicContent) {
    return dynamicContent
  }

  const fallbackRoot = html.createElement('div')
  const messageNodes = html.querySelectorAll(
    '[id*="component-text"], [id*="component-attachment"], [id*="component-image"]',
  )

  messageNodes.forEach((node) => {
    fallbackRoot.appendChild(node.cloneNode(true))
  })

  return fallbackRoot
}

const getSenderName = (
  parseCustomElement: (customElement: string) => {
    textContent: string;
    explanationPosition: string | null;
  },
) => {
  const senderName = parseCustomElement('component-required-fullname')

  if (senderName.textContent.trim()) {
    return senderName
  }

  return parseCustomElement('component-required-phone')
}
